import { motion } from "framer-motion";

const PageWrapper = ({ children }) => (
  <motion.div
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ duration: 0.4, ease: "anticipate" }}
    style={{ backgroundColor: "#000", minHeight: "100vh" }}
  >
    {children}
  </motion.div>
);

export default PageWrapper;
